'use client'
import classNames from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'

import Shared from '@/shared'
import Icons from '@/shared/components/icon/Icons'
import { Caption } from '@/shared/components/typography/index'
import type { colors, weights } from '@/styles/shared/typography'

interface Slides {
  title: string
  subtitle: string
  image: string
  href: string
  textColor: keyof typeof colors
  weight: keyof typeof weights
}

const SlideBanner = () => {
  const slides: Slides[] = [
    {
      title: '공항 주차대행 예매 OPEN!',
      subtitle: '발렛부터 픽업/샌딩까지 편하게',
      image: '/images/light_img_AirportParking.png',
      href: '/airport',
      textColor: 'text090',
      weight: 'bold'
    }
  ]

  const pathname = usePathname()
  const isMapPage = pathname === '/map'

  const { setIsAirportBannerClosed } = Shared.States.useStorageStore()

  const handleCloseBanner = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsAirportBannerClosed(true)
  }

  return (
    <div className="sticky top-0 z-99 w-full max-w-[768px]">
      <Swiper loop={false} allowTouchMove={false} className="overflow-hidden rounded-md">
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <Link
              href={slide.href}
              className={classNames(
                `flex w-full cursor-pointer items-center justify-between py-2 ${isMapPage ? 'pr-2' : 'pr-8'} bg-[#CFEDFF] pl-6`
              )}
            >
              <div className="flex flex-col">
                <Caption level="caption2" color={slide.textColor} weight="bold">
                  {slide.title}
                </Caption>
                <Caption level="caption3" color={slide.textColor} weight={slide.weight}>
                  {slide.subtitle}
                </Caption>
              </div>
              <div className="flex items-center gap-3">
                <Image src={slide.image} alt={slide.title} width={55} height={42} unoptimized />
                {isMapPage && (
                  <Icons.CircleCloseIcon
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation()
                      handleCloseBanner(e)
                    }}
                    className="z-300 cursor-pointer"
                  />
                )}
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default SlideBanner
